import { render, staticRenderFns } from "./AlertNewVersion.vue?vue&type=template&id=40126bdf&scoped=true"
import script from "./AlertNewVersion.vue?vue&type=script&lang=js"
export * from "./AlertNewVersion.vue?vue&type=script&lang=js"
import style0 from "./AlertNewVersion.vue?vue&type=style&index=0&id=40126bdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40126bdf",
  null
  
)

export default component.exports